<!--工程应用-->
<template>
  <div class="engineering">
    <!--顶部介绍-->
    <picture>
      <source media="(min-width: 768px)" srcset="@/assets/img/pc/about/about2/bakTop.png">
      <source media="(min-width: 320px)" srcset="@/assets/img/mobile/about/about2/bakTop.png">
      <img class="bakTop" src="@/assets/img/pc/about/about2/bakTop.png">
    </picture>
    <guide class="guide" :guide="guide" :color="'rgb(90, 137, 227)'"></guide>
    <!--主体内容-->
    <div class="x-container">
      <!--六个工程应用板块-->
      <div class="news">
        <el-row>
          <el-col :span="16">
            <div class="imgBox">
              <picture>
                <source media="(min-width: 768px)" :srcset="news[0].imgSrc">
                <source media="(min-width: 320px)" :srcset="news[0].imgSrcMobile">
                <img :srcs="news[0].imgSrc">
              </picture>
              <div class="info">
                <!--注意这个pre标签不能换行，否则会把换行的空格加上-->
                <!--<p>{{news[0].label}}</p>-->
                <pre>{{news[0].label}}</pre>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="imgBox">
              <picture>
                <source media="(min-width: 768px)" :srcset="news[1].imgSrc">
                <source media="(min-width: 320px)" :srcset="news[1].imgSrcMobile">
                <img :srcs="news[0].imgSrc">
              </picture>
              <div class="info">
                <!--注意这个pre标签不能换行，否则会把换行的空格加上-->
                <!--<p>{{news[1].label}}</p>-->
                <pre>{{news[1].label}}</pre>
              </div>
            </div>
            <div class="imgBox">
              <picture>
                <source media="(min-width: 768px)" :srcset="news[2].imgSrc">
                <source media="(min-width: 320px)" :srcset="news[2].imgSrcMobile">
                <img :srcs="news[2].imgSrc">
              </picture>
              <div class="info">
                <!--注意这个pre标签不能换行，否则会把换行的空格加上-->
                <!--<p>{{news[2].label}}</p>-->
                <pre>{{news[2].label}}</pre>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <div class="imgBox">
              <picture>
                <source media="(min-width: 768px)" :srcset="news[3].imgSrc">
                <source media="(min-width: 320px)" :srcset="news[3].imgSrcMobile">
                <img :srcs="news[3].imgSrc">
              </picture>
              <div class="info">
                <!--注意这个pre标签不能换行，否则会把换行的空格加上-->
                <!--<p>{{news[3].label}}</p>-->
                <pre>{{news[3].label}}</pre>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="imgBox">
              <picture>
                <source media="(min-width: 768px)" :srcset="news[4].imgSrc">
                <source media="(min-width: 320px)" :srcset="news[4].imgSrcMobile">
                <img :srcs="news[4].imgSrc">
              </picture>
              <div class="info">
                <!--注意这个pre标签不能换行，否则会把换行的空格加上-->
                <!--<p>{{news[4].label}}</p>-->
                <pre>{{news[4].label}}</pre>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="imgBox">
              <picture>
                <source media="(min-width: 768px)" :srcset="news[5].imgSrc">
                <source media="(min-width: 320px)" :srcset="news[5].imgSrcMobile">
                <img :srcs="news[5].imgSrc">
              </picture>
              <div class="info">
                <!--注意这个pre标签不能换行，否则会把换行的空格加上-->
                <!--<p>{{news[5].label}}</p>-->
                <pre>{{news[5].label}}</pre>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <!--工程应用列表(PC端)-->
      <div class="lists">
        <ul>
          <div v-for="(item,index) in newsList" :key="index">
            <li  v-if="(currentPage-1)*pagesize<=index &&index<currentPage*pagesize">
              <div class="engineering">
                <div class="left">
                  <picture>
                    <source media="(min-width: 768px)" :srcset="item.imgSrc">
                    <source media="(min-width: 320px)" :srcset="item.imgSrcMobile">
                    <img :src="item.imgSrc">
                  </picture>
                </div>
                <div class="right">
                  <p class="title">{{item.title}}</p>
                  <p class="des">{{item.label}}</p>
                </div>
              </div>
            </li>
          </div>
        </ul>
        <el-pagination class="pagination" style="margin-top: 20px;text-align: center"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="currentPage"
                       :page-sizes="[4,8]"
                       :page-size="pagesize"
                       layout="total,sizes, prev, pager, next, jumper"
                       :total="newsList.length">
        </el-pagination>
      </div>
      <!--工程应用列表(移动端)-->
      <div class="listsMobile">
        <ul
          class="list"
          v-infinite-scroll="load"
          infinite-scroll-disabled="disabled"
        >
          <div v-for="(item,index) in newsList" :key="index">
            <li class="list-item"
                v-if="index<=count"
            >
              <div class="engineering">
                <div class="left">
                  <picture>
                    <source media="(min-width: 768px)" :srcset="item.imgSrc">
                    <source media="(min-width: 320px)" :srcset="item.imgSrcMobile">
                    <img :src="item.imgSrc">
                  </picture>
                </div>
                <div class="right">
                  <p class="title">{{item.title}}</p>
                  <p class="des">{{item.label}}</p>
                </div>
              </div>
            </li>
          </div>
        </ul>
        <p v-if="loading">加载中...</p>
        <p v-if="noMore">没有更多了</p>
        <!--<ul>-->
        <!--<li v-for="(item,index) in newsList" v-if="(currentPage-1)*pagesize<=index &&index<currentPage*pagesize">-->
        <!--<div class="engineering">-->
        <!--<div class="left">-->
        <!--<picture>-->
        <!--<source media="(min-width: 768px)" :srcset="item.imgSrc">-->
        <!--<source media="(min-width: 320px)" :srcset="item.imgSrcMobile">-->
        <!--<img :src="item.imgSrc">-->
        <!--</picture>-->
        <!--</div>-->
        <!--<div class="right">-->
        <!--<p class="title">{{item.title}}</p>-->
        <!--<p class="des">{{item.label}}</p>-->
        <!--</div>-->
        <!--</div>-->
        <!--</li>-->
        <!--</ul>-->
      </div>
    </div>
  </div>
</template>

<script>
  import guide from '@/components/guide'
  import blueTitle from '@/components/blueTitle'

  export default {
    name: "engineering",
    components: {
      guide,
    },
    data() {
      return {
        guide: [
          // {label: '格力智能楼宇'},
          {label: '工程应用'},
        ],
        // 上面五个新闻图片
        news: [
          {
            label: '珠海格力总部商用研发大楼',
            imgSrc: require("@/assets/img/pc/engineering/pic1.png"),
            imgSrcMobile: require("@/assets/img/mobile/engineering/pic1.png"),
          },
          {
            label: '沙特达曼Basic公司办公楼',
            imgSrc: require("@/assets/img/pc/engineering/pic2.png"),
            imgSrcMobile: require("@/assets/img/mobile/engineering/pic2.png"),
          },
          {
            label: '华南理工大学',
            imgSrc: require("@/assets/img/pc/engineering/huananligong.png"),
            imgSrcMobile: require("@/assets/img/mobile/engineering/huananligong.png"),
          },
          {
            label: '湖南格力核心科技体验馆',
            imgSrc: require("@/assets/img/pc/engineering/pic4.png"),
            imgSrcMobile: require("@/assets/img/mobile/engineering/pic4.png"),
          },
          {
            label: '美国费城',
            imgSrc: require("@/assets/img/pc/engineering/pic5.png"),
            imgSrcMobile: require("@/assets/img/mobile/engineering/pic5.png"),
          },
          {
            label: '广州白云机场',
            imgSrc: require("@/assets/img/pc/engineering/pic6.png"),
            imgSrcMobile: require("@/assets/img/mobile/engineering/pic6.png"),
          },
        ],
        // 新闻列表
        pagesize: 4,
        currentPage: 1,
        newsList: [
          {
            title: '珠海格力总部商用研发大楼',
            imgSrc: require("@/assets/img/mobile/engineering/pic1.png"),
            imgSrcMobile: require("@/assets/img/mobile/engineering/pic1.png"),
            label: '项目涉及HVAC、送排风、照明、能源管理、视频监控、门禁管理、工位管理、智慧消防等8个系统，项目基于GBMS格力楼宇管理平台，实现智慧建筑的综合性自动化管理，打造健康、安全、节能、高效的智慧建筑体系。'
          },
          {
            title: '沙特达曼办公楼',
            imgSrc: require("@/assets/img/pc/engineering/pic7.png"),
            imgSrcMobile: require("@/assets/img/mobile/engineering/pic7.png"),
            label: 'GBMS格力智慧建筑平台为该项目提供智慧暖通一站式解决方案，实现实时监控风冷螺杆机组、光伏离心机冷水机组等多种设备的运行状态和故障状态，可达到绿色高效无人值守、温差优化控制、主动精准适配控制以及设备信息化管理。'
          },
          {
            title: '湖南格力核心科技体验馆',
            imgSrc: require("@/assets/img/pc/engineering/hunan.png"),
            imgSrcMobile: require("@/assets/img/mobile/engineering/hunan.png"),
            label: '项目涉及客流统计、门禁管理、工位管理、智能照明、背景音乐、停车场管理等6个系统，展馆内搭载GBMS格力楼宇管理平台，实现设备的远程集中控制，通过数据统计分析帮助工作人员合理分配资源，搭配智能场景与自动化控制策略，减少人为操作的繁琐。'
          },
          {
            title: '广州白云国际机场',
            imgSrc: require("@/assets/img/pc/engineering/jichang.png"),
            imgSrcMobile: require("@/assets/img/mobile/engineering/jichang.png"),
            label: '项目涉及空调系统，共安装千余台GMV5S系列机组，同时采用了格力分布式远程监控系统，使设备管理智能化，提高管理效率并实现系统性的节能运行方案，为机场航站楼提供了舒适的环境。'
          },
          {
            title: '美国费城',
            imgSrc: require("@/assets/img/pc/engineering/pic8.png"),
            imgSrcMobile: require("@/assets/img/mobile/engineering/pic8.png"),
            label: '项目涉及多联机系统、空调计费系统，工程共安装多联热泵室外机组超过100台，内机超过1200台，实现空调的可视化管理，自动公平分摊计量空调电量，解决了物业空调设备的运维困难。'
          },
          {
            title: '成都地铁四号线',
            imgSrc: require("@/assets/img/pc/engineering/chengdu.png"),
            imgSrcMobile: require("@/assets/img/mobile/engineering/chengdu.png"),
            label: '项目涉及空调系统、新风系统，全线采用了格力GMV5系列多联机及新风机组，同时使用格力远程监控系统进行集成化、自动化的运维管理，使设备的运行状态、故障状态可视化，便于及时调整系统参数及排除故障，减轻设备运维管理的压力，保障地铁线路全年的可靠运行。'
          },
          {
            title: '华南理工大学',
            imgSrc: require("@/assets/img/pc/engineering/huananligong.png"),
            imgSrcMobile: require("@/assets/img/mobile/engineering/huananligong.png"),
            label: '项目涉及空调系统、计费系统，采用格力GMV5 ES系列多联机，充分利用多联机的优势保护古建筑的外墙结构，采用格力多联机智能计费系统，按实际使用情况进行费用分摊，同时计费系统对接校园一卡通，为学生提供便捷的充值渠道，提高系统的便利性。'
          },
          {
            title: '合肥青网科技产业园 ',
            imgSrc: require("@/assets/img/pc/engineering/hefei.png"),
            imgSrcMobile: require("@/assets/img/mobile/engineering/hefei.png"),
            label: '项目涉及空调系统、计费系统，全部采用格力GMV5系列多联机，通过格力多联机智能计费系统实现多联机集中统一的园区化管理，并按实际使用情况进行电费分摊，为创业者提供了公平、舒适环境，提高园区服务质量。'
          },
        ],
        // 移动端新闻列表
        count: 3,
        loading: false
      }
    },
    methods: {
      handleSizeChange(val) {
        this.pagesize = val
      },
      handleCurrentChange(val) {
        this.currentPage = val;
      },
      load() {
        this.loading = true
        setTimeout(() => {
          this.count += 5
          this.loading = false
        }, 2000)
      }
    },
    computed: {
      noMore() {
        return this.count >= 4
      },
      disabled() {
        return this.loading || this.noMore
      }
    },
  }
</script>

<style scoped lang="less">
  .engineering {
    position: relative;
    .bakTop {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      margin: auto;
    }
    .guide {
      position: relative;
      top: 2rem;
    }
    /*工程应用板块*/
    .x-container {
      /*六个工程应用板块*/
      .news {
        margin-bottom: 3rem;
        .imgBox {
          position: relative;
          margin: 5px;
          box-sizing: border-box;
          img {
            width: 100%;
          }
          .info {
            text-align: left;
            position: absolute;
            bottom: 0;
            background: rgba(0, 0, 0, 0.55);
            width: 100%;
            height: 2rem;
            line-height: 2rem;
            margin: 0;
            padding-left: 1rem;
            box-sizing: border-box;
            color: #fff;
            /*display: flex;*/
            /*align-items: center;*/
            pre {
              overflow: hidden;
              text-overflow: ellipsis;
              font-family:'Avenir',Helvetica, Arial, sans-serif;
              margin: 0 auto;
            }
          }
        }
      }
      /*工程应用列表*/
      .lists {
        display: block;
        li {
          .engineering {
            /*height: 10rem;*/
            display: flex;
            align-items: center;
            margin-bottom: 1rem;
            border-right: 5px solid @blue;
            box-sizing: border-box;
            background: rgb(243, 248, 255);
            width: 100%;
            .left {
              width: 30%;
              img {
                width: 100%;
              }
            }
            .right {
              padding-left: 1rem;
              width: 80%;
              box-sizing: border-box;
              .title {
                text-align: left;
                color: @deepblue;
                font-weight: bold;
              }
              .des {
                text-align: left;
                text-indent: 2rem;
                margin-top: 1rem;
              }
            }
          }
        }
      }
      .listsMobile {
        height: 40rem;
        display: none;
        overflow: auto;
        li {
          .engineering {
            /*height: 10rem;*/
            display: flex;
            align-items: center;
            margin-bottom: 1rem;
            border-right: 5px solid @blue;
            box-sizing: border-box;
            background: rgb(243, 248, 255);
            width: 100%;
            .left {
              width: 30%;
            }
            .right {
              width: 80%;
              box-sizing: border-box;
              .title {
                text-align: left;
                color: @deepblue;
                font-weight: bold;
              }
              .des {
                text-align: left;
                text-indent: 2rem;
                margin-top: 1rem;
              }
            }
          }
        }
      }
    }
  }

</style>
<style lang="less" scoped>
  @media only screen and (min-width: 320px) {
    /*工程应用列表*/
    .lists {
      display: none !important;
    }

    .listsMobile {
      display: block !important;
    }
  }

  @media only screen and (min-width: 768px) {
    /*工程应用列表*/
    .lists {
      display: block !important;
    }

    .listsMobile {
      display: none !important;
    }
  }
</style>
